
import Vue from "vue";
import RemoveDomain from "./RemoveDomain.vue";
import ListDomains from "./ListDomains.vue";
import SaasModeFunnel from "./SaasModeFunnel.vue";
import ListDeletedFunnels from "./ListDeletedFunnels.vue";
import ListDeletedPages from "./ListDeletedPages.vue";
import RestoreFunnelsByLocation from "./RestoreFunnelsByLocation.vue";
import SwitchFunnelType from "./SwitchFunnelType.vue";
import DomainDetails from "./DomainDetails.vue";
import DomainCertRegeneration from "./DomainCertRegeneration.vue";

export default Vue.extend({
  components: {
    RemoveDomain,
    ListDomains,
    SaasModeFunnel,
    ListDeletedFunnels,
    RestoreFunnelsByLocation,
    SwitchFunnelType,
    ListDeletedPages,
    DomainDetails,
    DomainCertRegeneration
}
});
